module.exports = __webpack_public_path__ + "od-arrow-right-grey-icon/od-arrow-right-grey-icon-ef254c412d3908ff8f27ca76a9267a10.svg";